<template>
  <div>
    <div
      class="list-entry"
      v-for="poll of polls"
      :key="poll.pollId"
      @click="$emit('onPollClick', poll.pollId)"
    >{{ poll.texts[lang] }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'poll-list',
  props: {
    polls: Array
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage'})
  }
};
</script>

<style lang="scss" scoped>
</style>
